// frontend/src/features/campaign/constants/campaignConstants.js

export const STATUS_OPTIONS = [
  { key: 'ALL', label: 'All Campaigns' },
  { key: 'ACTIVE', label: 'Active' },
  { key: 'PENDING_APPROVAL', label: 'Pending Approval' },
  { key: 'CHANGES_REQUESTED', label: 'Changes Requested' },
  { key: 'PAUSE_REQUESTED', label: 'Pause Requested' },
  { key: 'DRAFT', label: 'Draft' },
  { key: 'PAUSED', label: 'Paused' },
];

export const CAMPAIGN_TYPES = [
  'Customer Acquisition',
  'Account-Based Marketing (ABM)',
  'Inactive Re-engagement',
  'New Product / Feature Launch',
  'Upsell & Cross-sell Expansion',
  'Webinar & Executive Event Invitation',
];

export const INDUSTRY_SECTORS = [
  'Enterprise SaaS',
  'Fintech & Commercial Banking',
  'Logistics & Supply Chain',
  'Healthcare & MedTech',
  'Retail & E-commerce Chains',
  'Manufacturing & Industrial Tech',
  'Professional & Corporate Services',
];

export const TARGET_REGIONS = [
  'Malaysia & Singapore',
  'Malaysia (All States)',
  'Klang Valley & Selangor Hub',
  'Penang & Northern Industrial Hub',
  'Johor & Southern Corridor',
  'Southeast Asia (SEA Regional)',
  'Global / Multi-Region',
];

export const CURRENCIES = [
  'USD',
  'EUR',
  'GBP',
  'AUD',
  'CAD',
  'JPY',
  'CNY',
  'HKD',
  'SGD',
  'CHF',
  'INR',
  'MYR',
  'NZD',
];

export const CURRENCY_NAMES = {
  USD: 'US Dollar',
  EUR: 'Euro',
  GBP: 'British Pound',
  AUD: 'Australian Dollar',
  CAD: 'Canadian Dollar',
  JPY: 'Japanese Yen',
  CNY: 'Chinese Yuan',
  HKD: 'Hong Kong Dollar',
  SGD: 'Singapore Dollar',
  CHF: 'Swiss Franc',
  INR: 'Indian Rupee',
  MYR: 'Malaysian Ringgit',
  NZD: 'New Zealand Dollar',
};

export const CURRENCY_SYMBOLS = {
  USD: '$',
  EUR: '€',
  GBP: '£',
  AUD: 'A$',
  CAD: 'C$',
  JPY: '¥',
  CNY: '¥',
  HKD: 'HK$',
  SGD: 'S$',
  CHF: 'CHF',
  INR: '₹',
  MYR: 'RM',
  NZD: 'NZ$',
};

export const CURRENCY_FLAGS = {
  USD: '🇺🇸',
  EUR: '🇪🇺',
  GBP: '🇬🇧',
  AUD: '🇦🇺',
  CAD: '🇨🇦',
  JPY: '🇯🇵',
  CNY: '🇨🇳',
  HKD: '🇭🇰',
  SGD: '🇸🇬',
  CHF: '🇨🇭',
  INR: '🇮🇳',
  MYR: '🇲🇾',
  NZD: '🇳🇿',
};

export const CURRENCY_COUNTRY_CODES = {
  USD: 'us',
  EUR: 'eu',
  GBP: 'gb',
  AUD: 'au',
  CAD: 'ca',
  JPY: 'jp',
  CNY: 'cn',
  HKD: 'hk',
  SGD: 'sg',
  CHF: 'ch',
  INR: 'in',
  MYR: 'my',
  NZD: 'nz',
};

export const CURRENCY_OPTIONS = [
  { code: 'MYR', symbol: 'RM', label: 'RM (MYR)', name: 'Malaysian Ringgit', flag: '🇲🇾' },
  { code: 'USD', symbol: '$', label: '$ (USD)', name: 'US Dollar', flag: '🇺🇸' },
  { code: 'SGD', symbol: 'S$', label: 'S$ (SGD)', name: 'Singapore Dollar', flag: '🇸🇬' },
  { code: 'EUR', symbol: '€', label: '€ (EUR)', name: 'Euro', flag: '🇪🇺' },
  { code: 'GBP', symbol: '£', label: '£ (GBP)', name: 'British Pound', flag: '🇬🇧' },
  { code: 'CNY', symbol: '¥', label: '¥ (CNY)', name: 'Chinese Yuan', flag: '🇨🇳' },
  { code: 'JPY', symbol: '¥', label: '¥ (JPY)', name: 'Japanese Yen', flag: '🇯🇵' },
  { code: 'AUD', symbol: 'A$', label: 'A$ (AUD)', name: 'Australian Dollar', flag: '🇦🇺' },
  { code: 'HKD', symbol: 'HK$', label: 'HK$ (HKD)', name: 'Hong Kong Dollar', flag: '🇭🇰' },
  { code: 'INR', symbol: '₹', label: '₹ (INR)', name: 'Indian Rupee', flag: '🇮🇳' },
  { code: 'CAD', symbol: 'C$', label: 'C$ (CAD)', name: 'Canadian Dollar', flag: '🇨🇦' },
  { code: 'CHF', symbol: 'CHF', label: 'CHF', name: 'Swiss Franc', flag: '🇨🇭' },
  { code: 'NZD', symbol: 'NZ$', label: 'NZD (NZ$)', name: 'New Zealand Dollar', flag: '🇳🇿' },
];

export const AVAILABLE_PERSONAS = [
  'Vice President of Sales (VP Sales)',
  'Chief Revenue Officer (CRO)',
  'Head of Business Development',
  'Chief Executive Officer (CEO)',
  'Chief Financial Officer (CFO)',
  'Treasury Director / VP Finance',
  'Chief Information Officer (CIO)',
  'Chief Technology Officer (CTO)',
  'VP of Engineering',
  'Operations Director / COO',
  'Managing Director',
];

export const normalizePersonaName = (name) => {
  if (!name || typeof name !== 'string') return name;
  const clean = name.trim();
  const lower = clean.toLowerCase();

  // CEO
  if (
    /^(chief executive officer|ceo)$/i.test(lower) ||
    lower.startsWith('chief executive officer (')
  ) {
    return 'Chief Executive Officer (CEO)';
  }
  // CFO
  if (
    /^(chief financial officer|cfo)$/i.test(lower) ||
    lower.startsWith('chief financial officer (')
  ) {
    return 'Chief Financial Officer (CFO)';
  }
  // CTO
  if (
    /^(chief technology officer|cto)$/i.test(lower) ||
    lower.startsWith('chief technology officer (')
  ) {
    return 'Chief Technology Officer (CTO)';
  }
  // CIO
  if (
    /^(chief information officer|cio)$/i.test(lower) ||
    lower.startsWith('chief information officer (')
  ) {
    return 'Chief Information Officer (CIO)';
  }
  // CRO
  if (/^(chief revenue officer|cro)$/i.test(lower) || lower.startsWith('chief revenue officer (')) {
    return 'Chief Revenue Officer (CRO)';
  }
  // COO / Operations Director
  if (
    /^(chief operating officer|coo|operations director)$/i.test(lower) ||
    lower.includes('operations director / coo') ||
    lower.includes('operations director/coo')
  ) {
    return 'Operations Director / COO';
  }
  // VP Sales / Vice President of Sales
  if (
    /^(vice president of sales|vp of sales|vp sales)$/i.test(lower) ||
    lower.startsWith('vice president of sales (')
  ) {
    return 'Vice President of Sales (VP Sales)';
  }
  // VP Engineering / Vice President of Engineering
  if (/^(vice president of engineering|vp of engineering|vp engineering)$/i.test(lower)) {
    return 'VP of Engineering';
  }
  // Treasury Director / VP Finance
  if (
    /^(treasury director|vp of finance|vp finance)$/i.test(lower) ||
    lower.includes('treasury director / vp finance')
  ) {
    return 'Treasury Director / VP Finance';
  }
  // Managing Director
  if (/^(managing director|md)$/i.test(lower)) {
    return 'Managing Director';
  }
  // Head of Business Development
  if (/^(head of business development|head of bd|director of business development)$/i.test(lower)) {
    return 'Head of Business Development';
  }

  // Check case-insensitive match or match stripping parentheses
  for (const avail of AVAILABLE_PERSONAS) {
    if (avail.toLowerCase() === lower) return avail;
    const strippedAvail = avail
      .replace(/\s*\([^)]*\)/g, '')
      .trim()
      .toLowerCase();
    const strippedName = clean
      .replace(/\s*\([^)]*\)/g, '')
      .trim()
      .toLowerCase();
    if (strippedAvail === strippedName) return avail;
  }

  return clean;
};

export const ALL_CHANNELS = [
  { id: 'Email', icon: 'fas fa-envelope', label: 'Email Outreach' },
  { id: 'LinkedIn', icon: 'fab fa-linkedin-in', label: 'LinkedIn / InMail' },
  { id: 'WhatsApp', icon: 'fab fa-whatsapp', label: 'WhatsApp Direct' },
  { id: 'Telegram', icon: 'fab fa-telegram-plane', label: 'Telegram Direct' },
  { id: 'Phone Call', icon: 'fas fa-phone-alt', label: 'Sales Phone Call' },
];

export const GOVERNANCE_GATES = [
  {
    id: 'brand_voice',
    title: 'Brand Voice & Messaging Approval',
    desc: 'Verify that positioning, tone, and proof claims comply with brand guidelines.',
  },
  {
    id: 'commercial',
    title: 'Commercial & Budget Gate',
    desc: 'Confirm allocated budget (RM) and expected revenue ROI benchmarks.',
  },
  {
    id: 'compliance_deliverability',
    title: 'Compliance & Deliverability Gate',
    desc: 'Validate sender domains, authentication records, and opt-out headers.',
  },
  {
    id: 'pdpa_privacy',
    title: 'PDPA & Privacy Regulatory Gate',
    desc: 'Verify consent provenance, suppression lists, and statutory regulatory compliance.',
  },
];

export const PRESET_PRODUCTS = [
  'Enterprise AI Lead Gen & Pipeline Engine',
  'Corporate Treasury & FX Risk Engine',
  'Next-Gen AI Prospect Finder',
  'Supply Chain AI Intelligence',
  'HealthTech Provider Suite',
];

export const LEAD_RESPONSE_TYPES = {
  INTERESTED: 'interested',
  NOT_INTERESTED: 'not_interested',
  NO_REPLY: 'no_reply',
};

/**
 * Canonicalizes any response string (e.g. 'positive' -> 'interested', 'negative' -> 'not_interested')
 * into the single unified variable: 'interested' | 'not_interested' | 'no_reply'.
 */
export const normalizeResponseType = (rawType) => {
  if (!rawType) return LEAD_RESPONSE_TYPES.NO_REPLY;
  const t = String(rawType).trim().toLowerCase();
  if (t === 'positive' || t === 'interested' || t === 'qualified' || t === 'won') {
    return LEAD_RESPONSE_TYPES.INTERESTED;
  }
  if (t === 'negative' || t === 'not_interested' || t === 'lost') {
    return LEAD_RESPONSE_TYPES.NOT_INTERESTED;
  }
  return LEAD_RESPONSE_TYPES.NO_REPLY;
};

/**
 * Safely extracts a displayable text string from any note representation
 * (string, array of note objects, single note object with { id, text, createdAt, createdBy, createdByName }, etc.)
 */
export const extractNoteText = (val) => {
  if (!val) return '';
  if (typeof val === 'string') return val;
  if (Array.isArray(val)) {
    const texts = val
      .map((item) => {
        if (!item) return '';
        if (typeof item === 'string') return item;
        if (typeof item === 'object') {
          return item.text || item.note || item.message || item.description || '';
        }
        return String(item);
      })
      .filter(Boolean);
    return texts.join('; ');
  }
  if (typeof val === 'object') {
    return val.text || val.note || val.message || val.description || '';
  }
  return String(val);
};
